// src/pages/analytics/itemSubcategories.ts
//
// Item subcategory (Invent.Subcat) filter helper shared by the sales filter
// bar, filter pane, Sales Detail, Order Sheet, Inventory and Transfers.

import type { AnalyticsFilters } from '../../types';

/**
 * Item subcategory options, narrowed to the chosen category when the agent
 * sends the category → subcategories map. null = agent too old (3.20.x and
 * earlier send no subcategories) → hide the control.
 */
export function subcategoryOptions(filters: AnalyticsFilters | undefined, itemCategory: string): string[] | null {
  if (!filters?.itemSubcategories) return null;
  if (itemCategory && filters.itemSubcategoryMap) return filters.itemSubcategoryMap[itemCategory] ?? [];
  return filters.itemSubcategories;
}
